module.exports = "https://cdn.hellotech.com/client-assets/video_doorbell_tablet_206eadaa8fcaa7a4e3d898085a67aae3.webp";